import { useCallback } from "react";
import { type NavigateOptions, useNavigate } from "react-router";

export function useNavigateTo(url: string, options?: NavigateOptions) {
  const navigate = useNavigate();

  const navigateTo = useCallback(() => {
    navigate(url, {
      flushSync: options?.flushSync,
      replace: options?.replace,
      state: options?.state,
      relative: options?.relative,
      preventScrollReset: options?.preventScrollReset,
      viewTransition: options?.viewTransition,
    });
  }, [
    navigate,
    url,
    options?.flushSync,
    options?.replace,
    options?.state,
    options?.relative,
    options?.preventScrollReset,
    options?.viewTransition,
  ]);

  return navigateTo;
}
